import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, email, service, date, message } = formData;

    const text = `🩺 *New Appointment Request - RV Clinic*%0A%0A` +
      `👤 *Name:* ${name}%0A` +
      `📞 *Phone:* ${phone}%0A` +
      `✉️ *Email:* ${email}%0A` +
      `🏥 *Service:* ${service}%0A` +
      `📅 *Preferred Date:* ${date}%0A` +
      `📝 *Message:* ${message || 'N/A'}%0A%0A` +
      `Sent from RV Clinic Website`;

    const whatsappUrl = `https://web.whatsapp.com/send?phone=917048944596&text=${text}`;
    window.open(whatsappUrl, '_blank');
  };

  const contactCards = [
    {
      icon: <Phone size={20} />,
      title: 'Phone',
      content: <a href="tel:+917048944596">+91 70489 44596</a>,
    },
    {
      icon: <Mail size={20} />,
      title: 'Email',
      content: <a href="mailto:contact@rvtechnologies.net.in">contact@rvtechnologies.net.in</a>,
    },
    {
      icon: <MapPin size={20} />,
      title: 'Address',
      content: <p>Tower T3, 7th Floor, 739, Sector Techzone-IV, Greater Noida (West), GautamBudh Nagar, Uttar Pradesh 201306</p>,
    },
    {
      icon: <Clock size={20} />,
      title: 'Working Hours',
      content: <p>Mon - Sat: 9:00 AM - 8:00 PM<br />Sunday: Emergency Only</p>,
    },
  ];

  return (
    <div className="contact-page">
      <section className="section">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>Have questions or need to book an appointment? Reach out to us and our team will assist you promptly.</p>
            <div className="contact-cards">
              {contactCards.map((card, i) => (
                <div className="contact-card" key={i}>
                  <div className="contact-icon">{card.icon}</div>
                  <div>
                    <h4>{card.title}</h4>
                    {card.content}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-form">
            <h3>Book an Appointment</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 98765 43210"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Select Service</label>
                  <select name="service" value={formData.service} onChange={handleChange} required>
                    <option value="">Choose a service</option>
                    <option value="Cardiology">Cardiology</option>
                    <option value="Orthopedics">Orthopedics</option>
                    <option value="Neurology">Neurology</option>
                    <option value="Pediatrics">Pediatrics</option>
                    <option value="General Medicine">General Medicine</option>
                    <option value="Diagnostics">Diagnostics</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Preferred Date</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message / Symptoms</label>
                <textarea
                  name="message"
                  placeholder="Describe your symptoms or any special requirements..."
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                />
              </div>
              <button type="submit" className="form-submit">
                Book Appointment via WhatsApp
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
